import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoliberacaoremota(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoliberacaoremota/FIND_OPERACAOLIBERACAOREMOTA':
      case '@operacaoliberacaoremota/UPDATE_OPERACAOLIBERACAOREMOTA':
      case '@operacaoliberacaoremota/DELETE_OPERACAOLIBERACAOREMOTA':
      case '@operacaoliberacaoremota/STORE_OPERACAOLIBERACAOREMOTA':
      case '@operacaoliberacaoremota/OPERACAOLIBERACAOREMOTA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoliberacaoremota/SUCCESS_REMOVE':
      case '@operacaoliberacaoremota/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoliberacaoremota/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoliberacaoremota;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoliberacaoremota/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoliberacaoremota;
        break;
      }

      case '@operacaoliberacaoremota/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
